import { login, getUserInfo, logout } from "@/api/login"
import { getToken, setToken, removeToken } from "@/utils/auth"

const loginStore = {
  state: {
    roles: [],
    perm: "",
    token: getToken(),
    isCollapse: false
  },
  //同步操作
  mutations: {
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERM: (state, perm) => {
      state.perm = perm
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    toggleSideBar(state) {
      //console.log("i am here ")
      state.isCollapse = !state.isCollapse
    }
  },
  //异步操作
  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then(response => {
            // 成功登录才设置token
            if (response && response.code === 20000) {
              //修改state状态
              //console.log(response.data.token)
              commit("SET_TOKEN", response.data.token)
              //保存到本地cokkies
              setToken(response.data.token)
            }
            // const data = response.data
            // commit("SET_TOKEN", data.token)
            // // 把token设置到cookie中,刷新页面的时候token会找不到，因此要本地持久化才可以
            // setToken(data.token)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户信息,权限什么的
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          //getUserInfo在axios那边也是返回一个Promise,then表示成功，catch表示捕捉失败
          .then(response => {
            const data = response.data
            if (data.roles && data.roles.length > 0) {
              commit("SET_ROLES", data.roles)
            } else {
              reject("roles must be a non-null array!")
            }
            commit("SET_PERM", data.ctrlperm)
            //确保之前的操作成功再resolve,如果出错则捕捉错误
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 登出
    Logout({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(res => {
            commit("SET_TOKEN", "")
            commit("SET_ROLES", [])
            removeToken()
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 前端请求userinfo出错的时候让其登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "")
        removeToken()
        resolve()
      })
    }

    // 动态修改权限
    // ChangeRoles({ commit, dispatch }, role) {
    //   return new Promise(resolve => {
    //     commit("SET_TOKEN", role)
    //     setToken(role)
    //     getUserInfo(role).then(response => {
    //       const data = response.data
    //       commit("SET_ROLES", data.roles)
    //       commit("SET_NAME", data.name)
    //       commit("SET_AVATAR", data.avatar)
    //       commit("SET_INTRODUCTION", data.introduction)
    //       dispatch("GenerateRoutes", data) // 动态修改权限后 重绘侧边菜单
    //       resolve()
    //     })
    //   })
    // }
  }
}

export default loginStore
